"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Button = /*#__PURE__*/
(0, _reactEmotion.default)('a', {
  target: "e1yiax60"
})(_base.default, ";", _font.default, ";height:44px;border-radius:2px;font-weight:600;color:#30373c;display:inline-flex;justify-content:center;align-items:center;overflow:hidden;box-shadow:", function (props) {
  return props.shadow ? '0 3px 3px 0 rgba(0,0,0,0.1)' : 'none';
}, ";font-size:14px;cursor:pointer;background-color:#fff;transition:all 0.3s ease;text-decoration:none;&:hover,&:focus{background-color:#fafafa;text-decoration:none;}& > span{height:100%;display:flex;justify-content:center;align-items:center;padding:0 14px;text-transform:uppercase;img{margin-right:5px;}}.count{background-color:#d6e2e6;text-transform:none;letter-spacing:0.02rem;}");
var GithubButton = function GithubButton(props) {
  return _react.default.createElement(Button, {
    href: props.href,
    target: props.target,
    shadow: props.shadow
  }, _react.default.createElement("span", null, props.icon || _react.default.createElement(_Icon.default, null), props.label), _react.default.createElement("span", {
    className: "count"
  }, props.count));
};
GithubButton.defaultProps = {
  target: '_self',
  label: 'Star on GitHub',
  shadow: false
};
GithubButton.propTypes = {
  href: _propTypes.string,
  target: _propTypes.string,
  icon: _propTypes.any,
  // eslint-disable-line
  label: _propTypes.any,
  // eslint-disable-line
  count: _propTypes.string,
  shadow: _propTypes.bool
};
var _default = GithubButton;
exports.default = _default;